export default __webpack_public_path__ + "static/baselogo-09eb4b87938b33fd5ed4efb495a20670.png";